import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const reportService = {
  get_report_client_service: (token, params) => {
    const uri = API_ROUTES.REPORT.GET_REPORT_CLIENT_SERVICE;
    return https.get(uri, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
  },
  get_report_client_profile: (token, params) => {
    const uri = API_ROUTES.REPORT.GET_REPORT_CLIENT_PROFILE;
    return https.get(uri, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
  },
  get_report_client_finance: (token, params) => {
    const uri = API_ROUTES.REPORT.GET_REPORT_CLIENT_FINANCE;
    return https.get(uri, {
      headers: { Authorization: `Bearer ${token}` },
      params,
    });
  },
  export_pdf: async (token, params) => {
    const uri = API_ROUTES.REPORT.EXPORT_PDF;
    const response = await https.get(uri, {
      headers: { Authorization: `Bearer ${token}` },
      params,
      responseType: "blob",
    });
    return response;
  },
};
